module.exports = __webpack_public_path__ + "images/62cf58c860d281149a1d365cfab4c8d8b439bb74e76e93ec5f127bb178c849b7.svg";